import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import {
  MenuAction,
  MenuDivider,
} from "src/app/components/core/eris-menu/eris-menu.component";
import { Audience } from "src/app/models/services/audience";
import { AudiencesService } from "src/app/services/audiences/audiences.service";
import { DialogService } from "src/app/services/core/dialog.service";
import { GlobalsService } from "src/app/services/globals.service";
import { UsersService } from "src/app/services/users.service";
import { ThemeOptions } from "src/app/theme-options";

@Component({
  selector: "app-audience-details",
  templateUrl: "./audience-details.component.html",
  styleUrls: ["./audience-details.component.sass"],
})
export class AudienceDetailsComponent implements OnInit {
  public heading: string = "";
  public subheading: string = "";
  public icon: string = "pe-7s-albums icon-gradient bg-midnight-bloom";
  headerMenuConfiguration: (MenuAction | MenuDivider)[] = [
    {
      label: "Back to audiences list",
      iconClass: "fa fa-arrow-circle-left",
      action: () => {
        this.location.back();
      },
    },
  ];

  audienceId: number;
  audience: Audience;
  selectedTabIndex: number = 0;
  loading = true;

  constructor(
    private globals: ThemeOptions,
    private route: ActivatedRoute,
    private audiencesServices: AudiencesService,
    private dialogService: DialogService,
    private spinnerService: NgxSpinnerService,
    private globalsService: GlobalsService,
    private usersService: UsersService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    // If no active company navigate to root
    if (
      !this.globalsService.getActiveCompany() ||
      !this.usersService.hasSelectedCompanyActionRight(
        "Audiences",
        "AudiencesList",
        "Manage"
      )
    ) {
      this.router.navigate(["/"]);
      return;
    }
    this.audienceId = +this.route.snapshot.paramMap.get("audienceId");
    this.loadAudience();
  }

  ngOnDestroy(): void {
    this.globals.backEnabled = false;
    this.globals.backLabel = "";
  }

  loadAudience(): void {
    this.spinnerService.show();
    this.audiencesServices.getAudience(this.audienceId).subscribe(
      (data: Audience) => {
        this.spinnerService.hide();
        this.audience = data;
        this.heading = `Audience '${this.audience.id} - ${this.audience.name}' details`;
        this.loading = false;
      },
      () => {
        this.spinnerService.hide();
        this.dialogService.showError("Error loading audience details");
        this.loading = false;
      }
    );
  }

  getStatusStyle = (index: number): string => {
    return "pe-7s-check";
  };

  getStatusLabel = (index: number): string => {
    return "Done";
  };
}
